
import request from '@/utils/request'
import api from './../common/base-url.config'
const headers = {
  'sysCode': 'ICAS'
}

/**
 *  查询当前用户的签约列表
 * @recordNo {string} 编码
 * @remark {string} 备注
 * @signTimeStart {string} 签署开始时间
 * @signTimeEnd {string} phoneNumber 手机号码
 * @termType {string} 协议名称
 * @termVersion    协议版本
 * @page
 * @pageSize
 */
export function signlist(data) {
  return request({
    url: api.getCurrentUserTermSignRecords,
    method: 'post',
    headers,
    data
  })
}

/**
 * 下拉获取协议名称
 * @param {string}
 * @returns {Object}
 */
export function getsignContent(params) {
  return request({
    url: api.getTermRichTextById,
    method: 'get',
    params
  })
}

/**
 * 下拉获取协议名称
 * @param {string}
 * @returns {Object}
 */
export function getsignName(params) {
  return request({
    url: api.signList,
    method: 'get',
    params
  })
}
